import { ActionTree, GetterTree, MutationTree } from "vuex";
import Vue from "vue";

let ignoreRefresh = false;

const initialState = {
  loadedOn: 0, // ms since epoch, as Date.now()
  model: {
    tenantId: 0,
    hasLogo: false,
    financialDocumentHeader: "",
    financialDocumentFooter: "",
    financialDocumentPaymentInstructions: "",
    nonFinancialDocumentHeader: "",
    documentKeyInfoTemplate: "",
    documentHouseRulesTemplate: ""
  },
};

const state = { ...initialState };

export type DocumentSettingsType = typeof state.model;

const getters: GetterTree<typeof state, any> = {
  loadedOn: (state) => state.loadedOn,
  isLoaded: (state) => state.loadedOn > 0,
  settings: (state) => state.loadedOn > 0 ? state.model : undefined,
};

const actions: ActionTree<typeof state, any> = {
  saveModel: async ({ commit }, model) => {
    ignoreRefresh = true;

    try {
      await Vue.axios.put("DocumentSettings", model);
      commit("setModel", model);
    } finally {
      ignoreRefresh = false;
    }
  },
  refreshModel: async ({ commit }) => {
    // in case it's already loading, this will stop making another call
    if (ignoreRefresh) {
      return;
    }

    ignoreRefresh = true;

    try {
      const loadPromise = Vue.axios
        .get<typeof state.model>("DocumentSettings")
        .then((x) => x.data);
      const res = await loadPromise;
      commit("setModel", res);
    } finally {
      ignoreRefresh = false;
    }
  },
};

const mutations: MutationTree<typeof state> = {
  reset: (state) => {
    Object.assign(state, initialState);
  },
  setModel: (state, value: typeof state.model) => {
    state.loadedOn = Date.now();
    state.model = value;
  },
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  actions,
  mutations,
};
